export default __webpack_public_path__ + "2e3944bd90ee7136de9f2209ac507c63.svg";